/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from "react";
import { Toaster } from "react-hot-toast";
import { Link } from "react-router-dom";
import jsPDF from "jspdf";
import "jspdf-autotable";
import SchoolContext from "../../../Context/SchoolContext";
import ajaxStudent from "../../../util/remote/ajaxStudent";
import AppContainer from "../../../Components/Structure/AppContainer";
import TableHeader from "../../../Components/Common/TableHeader";
import Loader from "../../../Components/Common/Loader";
import Pagination from "../../../Components/Common/Pagination";
import * as XLSX from "xlsx";
import Select from "react-select";
import ajaxStudentGroup from "../../../util/remote/ajaxStudentGroup";

function InactiveStudentsPage() {
    const {schoolList} = useContext(SchoolContext);
    const [query, setQuery] = useState("");
    const [school, setSchool] = useState("");
    const [group, setGroup] = useState("");

    const [page, setPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [loading2, setLoading2] = useState(false);
    const [weeks, setWeeks] = useState("");

    const [inactiveStudentCount, setInactiveStudentCount] = useState(false);
    // const [schoolCreditBalances, setSchoolCreditBalances] = useState([]);
    const [first, setFirst] = useState("");
    const [meta, setMeta] = useState([]);
    const [inactiveStudents, setInactiveStudents] = useState([]);
    const [printableInactiveStudents, setPrintableInactiveStudents] = useState([]);
    const [groupList, setGroupList] = useState(false);
      
    useEffect(() => {
        if (school) {
            getGroups(school);
        } else {
            setGroupList([]);
        }
    }, [school]);

  useEffect(() => {
      if (query || school || weeks || group) {
          searchInactiveStudents();
      } else {
          getInactiveStudents(page);
      }
  }, [page]);

  useEffect(() => {
        countInactiveStudents();
}, []);

useEffect(() => {
        printInactiveStudents();
}, [school, query, weeks, group]);

  const countInactiveStudents = async () => {
      const server_response = await ajaxStudent.countInactiveStudentAccounts();
      if (server_response.status === "OK") {
        setInactiveStudentCount(server_response.details);
      } else {
        setInactiveStudentCount("404");
      }
    };
  
  const getInactiveStudents = async (currentPage) => {
    setLoading(true);
    const server_response = await ajaxStudent.listAllInactiveStudents(currentPage);
    setLoading(false);

    if (server_response.status === "OK") {
      setFirst(server_response.details.meta.offset);
        setMeta(server_response.details.meta.totalPages);
        setInactiveStudents(server_response.details.data || []);
    } else {
        setInactiveStudents([]);
    }
};

const searchInactiveStudents = async (e) => {
    if (e) {
        e.preventDefault();
    }
    setLoading2(true);
    const server_response = await ajaxStudent.searchAllInactiveStudents(page, school, query, weeks, group);
    setLoading2(false);
    if (server_response.status === "OK") {
      setFirst(server_response.details.meta.offset);

        setMeta(server_response.details.meta.totalPages);
        setInactiveStudents(server_response.details.data || []);
    } else {
        setInactiveStudents([]);
    }
};

const printInactiveStudents = async () => {
      setLoading(true);
      const server_response = await ajaxStudent.printAllInactiveStudents(school, query, weeks, group);
      setLoading(false);
      if (server_response.status === "OK") {
          setPrintableInactiveStudents(server_response.details.data || []);
      } else {
          setPrintableInactiveStudents([]);
      }
    };

const getGroups = async (school) => {
          const server_response = await ajaxStudentGroup.fetchGroupList(school);
          if (server_response.status === "OK") {
              setGroupList(server_response.details);
          }
          else {
              setGroupList([]);
          }
    };

  const handlePagination = (newPage) => {
    if (newPage > 0 && newPage <= meta) {
      setPage(newPage);
    }
  };

  const setStudents = (e) => {
    e.preventDefault();
    setQuery("");
    setSchool("");
    setWeeks("")
    setPage(1);
    getInactiveStudents(1);
    
  };

  const handleStudentChange = (e) => {
    const value = e.target.value;
    setQuery(value);
    setPage(1);
    
    if (value === '') {
      setStudents(e);
    }
};



  const exportToPDF = () => {
      const pdf = new jsPDF("p", "pt", "a4");
      const columns = ["Student Name", "School Name", "Class", "Recent Activity"];
      const data = printableInactiveStudents.map(item => [
        item.fullname,
        item.school,
        item.group,
        item.days_ago
      ]);
  
      pdf.autoTable({ head: [columns], body: data });
      pdf.save("inactive_students_list.pdf");
  };

  const exportToExcel = () => {
          const worksheetData = printableInactiveStudents.map((item) => ({
            "Student Name": item.fullname,
            "School Name": item.school,
            "Class": item.group,
            "Recent Activity": item.days_ago
          }));
        
          const worksheet = XLSX.utils.json_to_sheet(worksheetData);
          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, "Inactive Students");
        
          XLSX.writeFile(workbook, "inactive_students_list.xlsx");
    };


  return (
    <AppContainer title="Inactive Students">
      <Toaster position="top-center" reverseOrder={false} />
        
       
        <div className="row">
            <div class="col-lg-12">
                <div class="card custom-card" style={{ paddingBottom: "10px" }}>
                    <div className="card-body map-card gradient-my-blue">
                        <div class="item-title mb-2" style={{ color: "white" }}>
                            <b>OVERALL</b>
                        </div>
                        <div class="row">
                        
                            <div class="col-xl-12 col-lg-12 col-sm-6 pr-0 pl-0">
                                <div class="text-center">
                                    <h2 class="mb-1 number-font" style={{ color: "white" }}>
                                        <span class="counter">
                                            {inactiveStudentCount? inactiveStudentCount.total_c:"..."}
                                        </span>
                                    </h2>
                                    <p class="mb-0 text-light"> No. of Inactive Students</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div className="row">
            <div className="col-lg-12 col-md-12 col-12 col-sm-12">
                <div className="row">
                <div className="col-lg-12 col-md-12 mt-3">
              <div className="card height-auto">
                <div className="card-body">
                <div class="heading-layout1 mg-b-5">
        <TableHeader
          title = "Inactive Student Accounts"
          subtitle="List of all student accounts that have had no recent activity for more than 1 month"    
        />
        <div class="dropdown">
            
          {/* <a class="dropdown-toggle" href="#" role="button" data-toggle="dropdown" aria-expanded="false">...</a> */}
          <Link class="" onClick={setStudents} role="button"><i class="fas fa-redo-alt ml-3"></i></Link>
          <Link class="" onClick={exportToPDF} role="button"><i class="fas fa-download ml-3"></i></Link>
          <Link class="" onClick={exportToExcel} role="button"><i class="fas fa-file-excel ml-3"></i></Link>


          
          {/* <div class="dropdown-menu dropdown-menu-right">
            <Link class="dropdown-item" onClick={setBalances}> <i class="fas fa-redo-alt text-orange-peel"></i>Refresh</Link>
          </div> */}
        </div>
      </div>

      <form className="mg-t-20" onSubmit={searchInactiveStudents}>
      <div className="row gutters-5">
        <div className="col-10-xxxl col-lg-10 col-12 form-group">
          <div className="row">
          <div className="col-lg-3 mt-2">
              <input
                type="text"
                placeholder="Enter first or last name..."
                style={{ border: "1px solid grey" }}
                value={query}
                onChange={handleStudentChange}
                className="form-control"
              />
            </div>
            <div className="col-lg-3 mt-2">
              <Select
                onChange={(e) => setSchool(e ? e.school_id : "")}
                getOptionLabel={(option) => option.school_name}
                getOptionValue={(option) => option.school_id}
                isSearchable
                placeholder="Select school..."
                options={Array.isArray(schoolList) ? schoolList : []}
                value={
                  school === ""
                    ? null
                    : Array.isArray(schoolList) &&
                      schoolList.find((value) => value.school_id === school)
                }
              />
            </div>
            {school &&<div className="col-lg-3 mt-2">
              <Select
                      onChange={(e) => setGroup(e.group_id)}
                      getOptionLabel={(option) => option.group_name}
                      getOptionValue={(option) => option.group_id}
                      isSearchable
                      placeholder="Select class..."
                      options={Array.isArray(groupList) ? groupList : []}
                      value={
                        group === ""? null: Array.isArray(groupList) &&
                        groupList.find((value) => value.group_id === group)
                      }
                    />
            </div>}
            <div className="col-lg-3 mt-2">
              <select
                    style={{border: "1px solid grey"}}
                    className="col-12 form-control"
                    value={weeks}
                    onChange={(e) => setWeeks(e.target.value)}>
                    <option value="" selected disabled>Select inactivity period..</option>
                    <option value="4">1 month</option>
                    <option value="8">2 months</option>
                    <option value="12">3 months</option>
                    <option value="16">4 months</option>

                </select>
            </div>
          </div>
        </div>

        <div className="col-2-xxxl col-lg-2 col-12 form-group">
          <button
            type="submit"
            className="btn-fill-lmd radius-30 text-light shadow-dodger-blue bg-dodger-blue ml-2"
          >
            SEARCH
          </button>
        </div>
      </div>
    </form>

      <div className="border-top mt-3"></div>
      <div className="table-responsive">
      {loading || loading2 ? (
        <Loader />
                      ) : (
        <table className="table display data-table text-nowrap">
            <thead>
                <tr>
                <th scope="col">No.</th>
                <th scope="col">Student Name</th>
                <th scope="col"> School</th>
                <th scope="col">Class</th>
                <th scope="col"> Recent Activity</th>
                
                </tr>
            </thead>
            <tbody>
                {inactiveStudents.length > 0 ? (
                    inactiveStudents.map((item, index) => (
                    <tr key={index}>
                        

                        <td>{index + first + 1} </td>
                        
                        <td><Link to={`/students/profile/${item.student_id}/${item.user_id}`}>{item.fullname}</Link></td>
                        

                        <td>{item.school}</td>
                        <td>{item.group}</td>
                        <td>{item.days_ago}</td>

                    </tr>
                    ))
                ) : (
                    <tr>
                        <td colSpan="5" style={{ textAlign: "center" }}>
                            No inactive students.
                        </td>
                    </tr>
                )}
            </tbody>
        </table>
      )}
        
      </div>
      <Pagination currentPage={page} totalPages={meta} onPageChange={handlePagination}/>
                </div>
              </div>
          </div>
                
                
                </div>
            </div>
            {/* <div class="col-lg-3 col-md-12 col-12 col-sm-12">
                <div className="row">
                {loading3 ? (
                    <Loader />
                      ):(
                        schoolCreditBalances.map((item, index) => (
                            <div key={index} class="col-lg-12 col-md-12 col-12 col-sm-12">
                                <div class="card custom-card">
                                    <div class="card-body">
                                        <div>
                                            <h6>{item.school_name}</h6>
                                            <h6><span class="fs-30 me-2" style={{fontSize:"20px"}}>{item.balance?item.balance.total_c:"..."}</span></h6>
                                        </div>
                                    </div>
                                </div>
                                
                            </div>)))}
                           
                    
                    
                </div>
            </div> */}
        </div>
        

        
      
    </AppContainer>
  );
}

export default InactiveStudentsPage;
